import { VIANUVEM_API_ENDPOINT } from './Defaults';
import { getVnSecret } from '../utility/utils';

let headers = {
  'Accept': 'application/json',
  'Content-Type': 'application/json'
}

class DocumentsAPI {

  static fetchDocuments = (workflowInstanceId, relatedDocuments) =>
    new Promise((resolve, reject) => {
      headers.vnSecret = getVnSecret();
      fetch(`${VIANUVEM_API_ENDPOINT}/api/document/search/processDocuments/${workflowInstanceId}`, {
        method: 'POST',
        body: JSON.stringify({ relatedDocuments }),
        headers: {
          vnSecret: getVnSecret(),
          'Content-Type': 'application/json',
        }
      })
      .then(res => {
        if (res.ok)
          res.json().then(function(response) {
            resolve(response);
          });
        else {
          res.json()
            .then(reject)
            .catch(() => reject())
        }
      })
      .catch(reject);
    });

}

export default DocumentsAPI;



// WEBPACK FOOTER //
// ./src/integrations/DocumentsAPI.js